<template>
  <div>
    <a-row type="flex" style="padding-top:20px;">
      <a-col :span="4" style="margin-right: 20px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">姓名</a-col>
          <a-col span="18">
            <a-input style="display:block" placeholder="请输入关键字" v-model="params.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="4" style="margin-right: 20px;">
        <a-row type="flex" align="top" :span="6">
          <a-col span="6" class="form-label">电话</a-col>
          <a-col span="18">
            <a-input style="display:block" placeholder="请输入关键字" v-model="params.tel"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6" style="margin-right: 20px;">
        <a-row type="flex" align="top" :span="6">
          <a-col span="6" class="form-label">组织机构</a-col>
          <a-col span="18">
            <a-cascader
              changeOnSelect
              :options="officeOptions"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              placeholder="请设置机构"
              style="display:block;width:100%;"
              v-model="params.office_id"
              @click="getOfficeOptions"
            >
              <a-icon slot="suffixIcon" :type="officeOptions ? 'down' : 'loading'" />
            </a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6" style="margin-right: 20px;">
        <a-row type="flex" align="top" :span="6">
          <a-col span="4" class="form-label">角色</a-col>
          <a-col span="10">
            <a-select defaultValue="" style="min-width:200px;" @change="handleSelect">
              <template v-for="role in roles">
                <a-select-option :value="role.id" :key="role.id">{{ role.name }}</a-select-option>
              </template>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between" style="padding-top:20px;">
      <a-col>
        <a-button type="primary" @click="handleSearch" style="padding: 0 25px">查询</a-button>
        <a-checkbox @change="onChange" style="margin-left: 20px;">仅查看正常账号</a-checkbox>
      </a-col>
      <a-col offset="2">
        <a-button
          type="primary"
          @click="$refs.editModal.show()"
          v-if="isGranted('office_setting.staff_manager.global_create')"
        >新建员工</a-button>
      </a-col>
    </a-row>
    <a-row :gutter="80" align="top" style="padding-top:20px;">
      <a-col>
        <a-table
          :pagination="pagination"
          :dataSource="tableData"
          :columns="columns"
          rowKey="uid"
          :loading="loading"
          @change="getData"
        >
          <template slot="status" slot-scope="status, record">
            <a-switch :checked="status == 1" @click="checkStatus(record)">
              {{
              record.name
              }}
            </a-switch>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-row type="flex" :gutter="10" justify="start">
              <a-col v-if="isGranted('office_setting.staff_manager.list_edit')">
                <a @click.prevent="$refs.editModal.show(record)">编辑</a>
              </a-col>
              <a-col v-if="isGranted('office_setting.staff_manager.list_delete')">
                <a @click.prevent="del(record)">删除</a>
              </a-col>
              <a-col>
                <a @click.prevent="$refs.transformStaffModal.show(record)">转移资料</a>
              </a-col>
            </a-row>
          </template>
        </a-table>
      </a-col>
    </a-row>
    <edit-staff-modal ref="editModal" @ok="getData()"></edit-staff-modal>
    <transform-staff-modal ref="transformStaffModal"></transform-staff-modal>
  </div>
</template>

<script>
import EditStaffModal from "./edit-staff-modal";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
import TransformStaffModal from "./transform-staff-modal.vue";
export default {
  name: "Staff",
  extends: baseComponentVue,
  data() {
    return {
      loading: false,
      roles: [],
      tableData: [],
      columns: [],
      officeOptions: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      params: {
        name: "",
        tel: "",
        office_id: [],
        normal_user: 0,
      }
    };
  },
  components: { EditStaffModal, TransformStaffModal },
  computed: {},
  created() {
    this.setColumns();
    this.getData();
    this.getAllRole();
  },
  methods: {
    getAllRole() {
      Api.system.getRoleList().then( res => {
        console.log(res);
        this.roles = res.roles;
        this.roles.unshift({
          name: '全部',
          id: ''
        })
      })
    },
    handleSelect(value) {
      if(value === '') {
        delete this.params.role_id;
      }
      this.params.role_id = value;
    },
    onChange(e) {
      if(e.target.checked) {
        this.params.normal_user = 1;
      } else {
        this.params.normal_user = 0;
      }
    },
    handleSearch() {
      this.pagination.current = 1;
      this.getData();
    },
    setColumns() {
      let columns = [
        { title: "姓名", dataIndex: "name" },
        { title: "电话", dataIndex: "tel" },
        { title: "账号", dataIndex: "email" },
        { title: "角色", dataIndex: "role_name" },
        { title: "组织关系", dataIndex: "office_path_name" },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
        // { title: "备注", dataIndex: "remark" }
      ];
      if (
        this.isAnyGranted([
          "office_setting.staff_manager.list_edit",
          "office_setting.staff_manager.list_delete"
        ])
      ) {
        columns.push({
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        });
      }
      this.columns = columns;
    },
    async getData(pagination, filters, sorter) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      }
      let params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        ...this.params,
        office_id: [...this.params.office_id].pop()
      };
      let response = await Api.office.getUserList(params);
      this.tableData = response.list;
      this.pagination.total = +response.total;
      this.loading = false;
    },
    async getOfficeOptions() {
      this.officeOptions = undefined;
      let { tree } = await Api.office.getTree();
      this.officeOptions = tree;
    },
    async checkStatus(record) {
      await Api.office.changeUserStatus({
        id: record.uid,
        status: record.status == "1" ? "2" : "1"
      });
      record.status = record.status == "1" ? "2" : "1";
    },
    del(record) {
      const h = this.$createElement;
      this.$confirm({
        title: "温馨提示",
        content: h("div", { style: { paddingTop: "20px" } }, [
          h("p", "确定要删除该数据"),
          h("p", "删除后系统将不再显示该数据信息")
        ]),
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            try {
              await Api.office.deleteUser({ user_id: record.uid });
              resolve();
              this.getData();
            } catch (e) {
              reject(e);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
